import { minuteMs, secondMs } from "verdi-common/timeConstants";

/**
 * The polling frequencies for the polling service
 */
export const POLLING_FREQUENCIES = {
    INFOCARD_OPEN: 10 * secondMs, // while any device card is open
    ZONE_INFOCARD_OPEN: 10 * secondMs, // while any zone info card is open
    MANUALMODE_TRANSITIONING: 3 * secondMs, // while any device on the account (regardless of card open state) is transitioning between manual and automatic modes
    DEFAULT: minuteMs, // while no other polling rules are active
} as const;

export type PollingFrequency = number;

/**
 * A rule set for polling
 *
 * A rule is a set of conditions at a certain polling frequency
 */
export interface PollingRule {
    id: string;
    frequency: PollingFrequency;
    getDeviceIdsForPolling: () => string[]; // determines which device ids to poll (runs every tick)
}
